module.exports = __webpack_public_path__ + "static/media/pause_icon.25b1d3d1.svg";